export default __webpack_public_path__ + "static/media/ic_set_destiny.f4f690bd.svg";